import React from 'react';
import '../../../../assets/css/Modal.css'
import {
    Modal,
} from 'react-bootstrap';
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import GradeManager from "../../../../components/Grade";
import {getSchoolYear} from "../../../../utils/authority";
import DiscountAdmissionsRegisterController
    from "../../../../services/system/discount-admissions-register/discount-admissions-register-controller";

class ModalCreateDiscountAdmissionsRegister extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '',
            discount: 0,
            gradeId: "ALL",
            status: true,
            state: "ACTIVE"
        };
    }
    UNSAFE_componentWillReceiveProps(nextProps, nextContext){
        if (nextProps.show){
            this.setState({showLoading: true},
                () => {
                    this.state = {
                        gradeId: "ALL",
                        status: true,
                        state: 'ACTIVE',
                    };
                }
            )
        }
    }
    createDiscount = () => {
        if (this.state.name.length < 3){
            toast.error("Tên khu vực phải lớn hơn 3 ký tự", {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 3000
            });
        }else if (this.state.discount <= 0){
            toast.error("Giảm giá phải lớn hơn 0!", {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 3000
            });
        }else if (this.state.gradeId.length < 1){
            toast.error("Vui lòng chọn khối áp dụng", {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 3000
            });
        }else {
            let payload = {
                "name": this.state.name,
                "discount": this.state.discount,
                "grade": this.state.gradeId,
                "state": this.state.state,
                "yearId": parseInt(getSchoolYear()),
            }
            DiscountAdmissionsRegisterController.create(payload, res => {
                if (res.success) {
                    toast.success("Thêm giảm giá thành công!", {
                        position: toast.POSITION.TOP_RIGHT,
                        autoClose: 3000
                    });
                    this.props.onHide();
                    this.props.onRefresh()
                } else {
                    toast.error("Có lỗi xảy ra!", {
                        position: toast.POSITION.TOP_RIGHT,
                        autoClose: 3000
                    });
                }
            })
        }
    }
    onUpdateGrade(gradeId){
        this.setState({
            gradeId: gradeId
        });
    }
    render() {
        const modalProp = {
            show: this.props.show,
            onHideModal: this.props.onHide,
            keyboard: false,
            backdrop: 'static',
        };
        let {gradeId} = this.state
        return (
            <div>
                <Modal {...modalProp} dialogClassName="modal-dialog-centered">
                    <div className="modal-container">
                        <div className="btn-close">
                            <button type="button" className="close" onClick={this.props.onHide}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                    </div>
                    <Modal.Body>
                        <div>
                            <h1 className="text-center" style={{fontSize: 20,}}><b>Thêm cấu hình giảm giá tuyển sinh đăng ký</b></h1>
                        </div>
                        <div className='d-flex justify-content-center mt-12 mb-12'>
                            <div className="row">

                                <div className="col-12 d-flex mb-2">
                                    <label className="col-6 label-item pl-0">Tên cấu hình giảm giá(<span  style={{color: "red",}}>*</span>)</label>
                                    <input
                                        maxLength={255}
                                        type="text"
                                        placeholder="Nhập tên"
                                        className="form-control shadow-none"
                                        value={this.state.name}
                                        onChange={(event) => {
                                            this.setState({
                                                name: event.target.value
                                            })
                                        }}
                                    />
                                </div>
                                <div className="col-12 d-flex mb-2">
                                    <label className="col-6 label-item pl-0">Giảm giá</label>
                                    <input
                                        placeholder="Nhập giảm giá"
                                        maxLength={255} type="text"
                                        className="form-control shadow-none"
                                        value={this.state.discount}
                                        onChange={(event) => {
                                            this.setState({
                                                discount: event.target.value
                                            })
                                        }}
                                    />
                                </div>
                                <div className="col-xs-12 col-sm-12 col-md-126 d-flex mb-2">
                                    <label className="col-6 label-item pl-0">Khối</label>
                                    <GradeManager
                                        gradeId={gradeId}
                                        onUpdateGrade={(gradeId) => this.onUpdateGrade(gradeId)}
                                    />
                                </div>
                                <div className="col-xs-12 col-sm-12 col-md-12 d-flex mb-2">
                                    <label className="col-6 label-item pl-0">Trạng thái</label>
                                    <select
                                        className="form-control kt-input pd-4-input hei-input"
                                        value={this.state.state}
                                        onChange={(e) => {
                                            this.setState({
                                                state: e.target.value,
                                            })
                                        }}
                                    >
                                        <option value="ACTIVE">Hoạt động</option>
                                        <option value="INACTIVE">Khóa</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div className="d-flex align-right col-md-12 col-xs-12 row">
                            <div className="d-flex justify-content-center align-center mt-3 mb-2 col-md-12 col-xs-12">
                                <button
                                    style={{minWidth: "fit-content", marginRight: "10px"}}
                                    type="button"
                                    className="col-md-2 col-xs-2 border-1-s background-btn w-50 type-button-fix btn btn-primary"
                                    onClick={() => this.createDiscount()}
                                >
                                        <span className='justify-content-center'>
                                            Lưu
                                        </span>
                                </button>
                                <button
                                    style={{minWidth: "fit-content"}}
                                    type="button"
                                    className="col-md-2 col-xs-2 border-1-s w-50 type-button-fix btn btn-secondary"
                                    onClick={this.props.onHide}
                                >
                                        <span className=''>
                                            Đóng
                                        </span>
                                </button>
                            </div>
                        </div>

                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}
export default ModalCreateDiscountAdmissionsRegister